/**
 * Important: Do not import setup here, as these functions are used in the index file!
 */
export const PageHelper = {
  loadLanguageContentAndSetLanguage(language, i18n) {
    return import(/* webpackChunkName: "lang-[request]" */ `@/language/content/content.${language}.json`).then(
      messages => {
        i18n.setLocaleMessage(language, messages.default)
        i18n.locale = language
        return messages
      }
    )
  },

  setPageTitleAndDescription(meta) {
    if (!meta) {
      throw new Error('Missing param meta')
    }

    // check, if DVP-"app" is present
    if (document.querySelector('div[app-name=Configurator]')) {
      document.querySelector('title').innerText = [process.env.VUE_APP_PAGE_TITLE_PREFIX, meta.title]
        .filter(x => !!x)
        .join(' ')
      document.querySelector('meta[name=description]').content = meta.description
    }
  },
}
